import React from 'react';
import { useQuery } from 'react-query';
import styled from 'styled-components';
import { REPORTS_URL } from '../../../utils/config';
import request from '../../../utils/request';

const Dashboard = () => {
  const { data } = useQuery(
    'analytics',
    async () => {
      const data = await request('/analytics/auth');
      return data;
    },
    {
      staleTime: 0,
    },
  );

  // console.log('dat', data);
  return (
    <Container>
      {data && (
        <iframe
          src={`${REPORTS_URL}/?appName=FreshSurvey&auth=${data}`}
          className="analytics-iframe"
          title="analytics-dashboard"
        />
      )}
      {/* <EmptyState
        imgSrc="empty-state-dashboard.svg"
        title="No reports to display"
        message="You don’t have any data yet to display the reports. Start collecting responses from your customers."
      >
        <Button type="primary" inline>
          Know more
        </Button>
      </EmptyState> */}
    </Container>
  );
};

export default Dashboard;

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  background-size: cover;

  .analytics-iframe {
    width: 100%;
    border: none;
    height: 100%;
  }
`;
